export const VALIDATOR_LOW_STAKE_GRACE_PERIOD = 7;
